import { AccountEndpoints } from '../types/Endpoints';

import { RequestService } from 'itaf';

class AccessService {
  getAccessByUserId(userId) {
    const requestUrl = AccountEndpoints.Access;
    return RequestService.getRequest(`${requestUrl}/${userId}/logs`);
  }

  getAccessChart() {
    const requestUrl = AccountEndpoints.Access;
    return RequestService.getRequest(`${requestUrl}/accessChart`);
  }

}  

export default new AccessService();
